import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import router from "../../router";
export default {
  name: 'mineNumberArr',
  data: function data() {
    return {
      mineNumberArr: {
        mineNumber: '666666',
        scalesName: '',
        scalesId: '',
        snJsonRefreshRate: '60',
        name: '',
        id: '',
        isdb14file: '0',
        iszfwfile: '0',
        issnjsonfile: '0',
        iscnb: 0,
        isdisplaydevicestatus: 0,
        ismotor: 0,
        ip: '',
        iscoalinforupload: 0,
        isUseReportGeneration: false,
        reportGenerationTime: 16,
        password: '',
        port: '',
        username: '',
        minename: '',
        minecode: '',
        threadStartupType: 0,
        menuBarBackgroundColor: '#999',
        homePageBackgroundColor: '#999',
        titleColor: '#999',
        textColor: '#999',
        buttonColor: '#999',
        buttonColor2: '#999',
        cloudip: '',
        cloudport: '0',
        cloudid: '',
        cloudusername: '',
        cloudpassword: '',
        iscloudupload: false,
        isflowcurve: false,
        iscolumnchart: false,
        isreceivepounddata: false,
        virtualname: '',
        isdtjkmy0002s: false
      },
      isReportGeneration: true,
      isUseDB14: true,
      isUseZFW: true,
      isUseSNJson: true,
      isDisplayCNB: true,
      isDisplayDevice: true,
      isUseMotor: true,
      isMessageCenter: true,
      isDisplayCompanyName: true,
      isMultithreading: true,
      isUseCoalInforUpload: true,
      isReceivePoundData: true,
      isCloudUpload: true,
      isFlowCurve: true,
      isColumnChart: true,
      isVirtual: false,
      isDTJKMY0002S: false,
      balanceArr: [],
      ReportGenerationTime: [{
        name: '0点',
        value: 0
      }, {
        name: '1',
        value: 1
      }, {
        name: '2',
        value: 2
      }, {
        name: '3',
        value: 3
      }, {
        name: '4',
        value: 4
      }, {
        name: '5',
        value: 5
      }, {
        name: '6',
        value: 6
      }, {
        name: '7',
        value: 7
      }, {
        name: '8',
        value: 8
      }, {
        name: '9',
        value: 9
      }, {
        name: '10',
        value: 10
      }, {
        name: '11',
        value: 11
      }, {
        name: '12',
        value: 12
      }, {
        name: '13',
        value: 13
      }, {
        name: '14',
        value: 14
      }, {
        name: '15',
        value: 15
      }, {
        name: '16',
        value: 16
      }, {
        name: '17',
        value: 17
      }, {
        name: '18',
        value: 18
      }, {
        name: '19',
        value: 19
      }, {
        name: '20',
        value: 20
      }, {
        name: '21',
        value: 21
      }, {
        name: '22',
        value: 22
      }, {
        name: '23',
        value: 23
      }]
    };
  },
  created: function created() {
    this.getSystemInfo();
    this.getBalances();
  },
  methods: {
    getSystemInfo: function getSystemInfo() {
      var _this = this;

      var serach = {};
      this.$zybhttp.get('Business/GetSystemInfo', {}).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data;
          _this.version = d.msg;
          _this.mineNumberArr.mineNumber = d.data.list[0].mineNumber;
          _this.mineNumberArr.snJsonRefreshRate = d.data.list[0].snJsonRefreshRate;
          _this.mineNumberArr.id = d.data.list[0].id;
          _this.mineNumberArr.name = d.data.list[0].name;
          _this.mineNumberArr.scalesName = d.data.list[0].scalesName;
          _this.mineNumberArr.scalesId = d.data.list[0].scalesId;
          _this.mineNumberArr.isdb14file = d.data.list[0].isDB14File;
          _this.mineNumberArr.iszfwfile = d.data.list[0].isZFWFile;
          _this.mineNumberArr.issnjsonfile = d.data.list[0].isSNJsonFile;
          _this.mineNumberArr.iscnb = d.data.list[0].isCNB;
          _this.mineNumberArr.isdisplaydevicestatus = d.data.list[0].isDisplayDeviceStatus;
          _this.mineNumberArr.ismotor = d.data.list[0].isMotor;
          _this.mineNumberArr.threadStartupType = d.data.list[0].threadStartupType;
          _this.mineNumberArr.iscoalinforupload = d.data.list[0].isCoalInforUpload;
          _this.mineNumberArr.ip = d.data.list[0].ip;
          _this.mineNumberArr.port = d.data.list[0].port;
          _this.mineNumberArr.username = d.data.list[0].userName;
          _this.mineNumberArr.password = d.data.list[0].passWord;
          _this.mineNumberArr.minename = d.data.list[0].mineName;
          _this.mineNumberArr.minecode = d.data.list[0].mineCode;
          _this.mineNumberArr.reportGenerationTime = d.data.list[0].reportGenerationTime;
          _this.mineNumberArr.menuBarBackgroundColor = d.data.list[0].menuBarBackgroundColor;
          _this.mineNumberArr.homePageBackgroundColor = d.data.list[0].homePageBackgroundColor;
          _this.mineNumberArr.titleColor = d.data.list[0].titleColor;
          _this.mineNumberArr.textColor = d.data.list[0].textColor;
          _this.mineNumberArr.buttonColor = d.data.list[0].buttonColor;
          _this.mineNumberArr.buttonColor2 = d.data.list[0].buttonColor2;
          _this.mineNumberArr.cloudip = d.data.list[0].cloudIP;
          _this.mineNumberArr.cloudport = d.data.list[0].cloudPort;
          _this.mineNumberArr.cloudid = d.data.list[0].cloudID;
          _this.mineNumberArr.cloudusername = d.data.list[0].cloudUserName;
          _this.mineNumberArr.cloudpassword = d.data.list[0].cloudPassWord;
          _this.mineNumberArr.iscloudupload = d.data.list[0].isCloudUpload;
          _this.mineNumberArr.isflowcurve = d.data.list[0].isFlowCurve;
          _this.mineNumberArr.iscolumnchart = d.data.list[0].isColumnChart;
          _this.mineNumberArr.isreceivepounddata = d.data.list[0].isReceivePoundData;
          _this.mineNumberArr.ismessagecenter = d.data.list[0].isMessageCenter;
          _this.mineNumberArr.isdisplaycompanyname = d.data.list[0].isDisplayCompanyName;
          _this.mineNumberArr.isvirtual = d.data.list[0].isVirtual;
          _this.mineNumberArr.virtualname = d.data.list[0].virtualName;
          _this.mineNumberArr.isdtjkmy0002s = d.data.list[0].isDTJKMY0002S;
          _this.isUseDB14 = d.data.list[0].isDB14File == 1 ? true : false;
          _this.isUseZFW = d.data.list[0].isZFWFile == 1 ? true : false;
          _this.isUseSNJson = d.data.list[0].isSNJsonFile == 1 ? true : false;
          _this.isDisplayCNB = d.data.list[0].isCNB == 1 ? true : false;
          _this.isDisplayDevice = d.data.list[0].isDisplayDeviceStatus == 1 ? true : false;
          _this.isUseMotor = d.data.list[0].isMotor == 1 ? true : false;
          _this.isUseCoalInforUpload = d.data.list[0].isCoalInforUpload == 1 ? true : false;
          _this.isReportGeneration = d.data.list[0].isUseReportGeneration == true ? true : false;
          _this.isMultithreading = d.data.list[0].threadStartupType == 1 ? true : false;
          _this.isCloudUpload = d.data.list[0].isCloudUpload == 1 ? true : false;
          _this.isFlowCurve = d.data.list[0].isFlowCurve == 1 ? true : false;
          _this.isColumnChart = d.data.list[0].isColumnChart == 1 ? true : false;
          _this.isReceivePoundData = d.data.list[0].isReceivePoundData == 1 ? true : false;
          _this.isMessageCenter = d.data.list[0].isMessageCenter == 1 ? true : false;
          _this.isDisplayCompanyName = d.data.list[0].isDisplayCompanyName == 1 ? true : false;
          _this.isVirtual = d.data.list[0].isVirtual == 1 ? true : false;
          _this.isDTJKMY0002S = d.data.list[0].isDTJKMY0002S == 1 ? true : false;
        } else {
          _this.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this.$notify.error('网络异常！获取列表失败！');
      });
    },
    saveEdit: function saveEdit() {
      var _this2 = this;

      this.$refs['mineNumberArr'].validate(function (valid) {
        _this2.mineNumberArr.scalesName = _this2.$refs.selectScales.selectedLabel;

        if (valid) {
          _this2.$zybhttp.post('SystemInfo/SetSystemInfo', _this2.mineNumberArr).then(function (res) {
            if (res.data.status == 0) {
              _this2.$notify.success('修改成功');

              _this2.getSystemInfo();
            } else {
              _this2.$notify.error('修改失败');
            }
          }).catch(function (err) {
            return _this2.$notify.error('网络异常！修改失败');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    saveSeconds: function saveSeconds() {
      var _this3 = this;

      this.$refs['mineNumberArr'].validate(function (valid) {
        if (valid) {
          _this3.$zybhttp.post('SystemInfo/SetSystemInfo', _this3.mineNumberArr).then(function (res) {
            var r = /^\+?[1-9][0-9]*$/; //正整数

            if (!r.test(_this3.mineNumberArr.snJsonRefreshRate)) {
              _this3.$alert("请输入正整数！");

              return;
            }

            ;

            if (res.data.status == 0) {
              _this3.$notify.success('修改成功');

              _this3.getSystemInfo();
            } else {
              _this3.$notify.error('修改失败');
            }
          }).catch(function (err) {
            return _this3.$notify.error('网络异常！修改失败');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    saveTime: function saveTime() {
      var _this4 = this;

      this.mineNumberArr.isUseReportGeneration = this.isReportGeneration;
      this.$refs['mineNumberArr'].validate(function (valid) {
        if (valid) {
          _this4.$zybhttp.post('SystemInfo/SetSystemInfo', _this4.mineNumberArr).then(function (res) {
            if (res.data.status == 0) {
              _this4.$notify.success('修改成功');

              _this4.getSystemInfo();
            } else {
              _this4.$notify.error('修改失败');
            }
          }).catch(function (err) {
            return _this4.$notify.error('网络异常！修改失败');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    changeDB14: function changeDB14() {
      var _this5 = this;

      this.mineNumberArr.isdb14file = this.isUseDB14 ? '1' : '0';
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this5.$notify.success('修改成功');

          _this5.getSystemInfo();
        } else {
          _this5.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this5.$notify.error('网络异常！修改失败');
      });
    },
    changeZFW: function changeZFW() {
      var _this6 = this;

      this.mineNumberArr.iszfwfile = this.isUseZFW ? '1' : '0';
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this6.$notify.success('修改成功');

          _this6.getSystemInfo();
        } else {
          _this6.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this6.$notify.error('网络异常！修改失败');
      });
    },
    changeDTJKMY0002S: function changeDTJKMY0002S() {
      var _this7 = this;

      this.mineNumberArr.isdtjkmy0002s = this.isDTJKMY0002S ? true : false;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this7.$notify.success('修改成功');

          _this7.getSystemInfo();
        } else {
          _this7.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this7.$notify.error('网络异常！修改失败');
      });
    },
    changeSNJson: function changeSNJson() {
      var _this8 = this;

      this.mineNumberArr.issnjsonfile = this.isUseSNJson ? '1' : '0';
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this8.$notify.success('修改成功');

          _this8.getSystemInfo();
        } else {
          _this8.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this8.$notify.error('网络异常！修改失败');
      });
    },
    changeVirtual: function changeVirtual() {
      var _this9 = this;

      this.mineNumberArr.isvirtual = this.isVirtual ? true : false;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this9.$notify.success('修改成功');

          _this9.getSystemInfo();
        } else {
          _this9.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this9.$notify.error('网络异常！修改失败');
      });
    },
    changeReportGeneration: function changeReportGeneration() {
      var _this10 = this;

      this.mineNumberArr.isUseReportGeneration = this.isReportGeneration ? true : false;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this10.$notify.success('修改成功');

          _this10.getSystemInfo();
        } else {
          _this10.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this10.$notify.error('网络异常！修改失败');
      });
    },
    changeCNB: function changeCNB() {
      var _this11 = this;

      this.mineNumberArr.iscnb = this.isDisplayCNB ? 1 : 0;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this11.$notify.success('修改成功');

          _this11.getSystemInfo();
        } else {
          _this11.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this11.$notify.error('网络异常！修改失败');
      });
    },
    changeDeviceStatus: function changeDeviceStatus() {
      var _this12 = this;

      this.mineNumberArr.isdisplaydevicestatus = this.isDisplayDevice ? 1 : 0;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this12.$notify.success('修改成功');

          _this12.getSystemInfo();
        } else {
          _this12.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this12.$notify.error('网络异常！修改失败');
      });
    },
    changeMotor: function changeMotor() {
      var _this13 = this;

      this.mineNumberArr.ismotor = this.isUseMotor ? 1 : 0;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this13.$notify.success('修改成功');

          _this13.getSystemInfo();
        } else {
          _this13.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this13.$notify.error('网络异常！修改失败');
      });
    },
    changeMessageCenter: function changeMessageCenter() {
      var _this14 = this;

      this.mineNumberArr.ismessagecenter = this.isMessageCenter ? true : false;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this14.$notify.success('修改成功');

          _this14.getSystemInfo();
        } else {
          _this14.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this14.$notify.error('网络异常！修改失败');
      });
    },
    changeDisplayCompanyName: function changeDisplayCompanyName() {
      var _this15 = this;

      this.mineNumberArr.isdisplaycompanyname = this.isDisplayCompanyName ? true : false;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this15.$notify.success('修改成功');

          _this15.getSystemInfo();
        } else {
          _this15.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this15.$notify.error('网络异常！修改失败');
      });
    },
    changeMultithreading: function changeMultithreading() {
      var _this16 = this;

      this.mineNumberArr.threadStartupType = this.isMultithreading ? 1 : 0;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this16.$notify.success('修改成功');

          _this16.getSystemInfo();
        } else {
          _this16.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this16.$notify.error('网络异常！修改失败');
      });
    },
    changeCoalInfoSupervision: function changeCoalInfoSupervision() {
      var _this17 = this;

      this.mineNumberArr.iscoalinforupload = this.isUseCoalInforUpload ? 1 : 0;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this17.$notify.success('修改成功');

          _this17.getSystemInfo();
        } else {
          _this17.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this17.$notify.error('网络异常！修改失败');
      });
    },
    changeReceivePoundData: function changeReceivePoundData() {
      var _this18 = this;

      this.mineNumberArr.isreceivepounddata = this.isReceivePoundData ? true : false;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this18.$notify.success('修改成功');

          _this18.getSystemInfo();
        } else {
          _this18.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this18.$notify.error('网络异常！修改失败');
      });
    },
    changeCloudUpload: function changeCloudUpload() {
      var _this19 = this;

      this.mineNumberArr.iscloudupload = this.isCloudUpload ? true : false;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this19.$notify.success('修改成功');

          _this19.getSystemInfo();
        } else {
          _this19.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this19.$notify.error('网络异常！修改失败');
      });
    },
    changeFlowCurveStatus: function changeFlowCurveStatus() {
      var _this20 = this;

      this.mineNumberArr.isflowcurve = this.isFlowCurve ? true : false;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this20.$notify.success('修改成功');

          _this20.getSystemInfo();
        } else {
          _this20.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this20.$notify.error('网络异常！修改失败');
      });
    },
    changeColumnChartStatus: function changeColumnChartStatus() {
      var _this21 = this;

      this.mineNumberArr.iscolumnchart = this.isColumnChart ? true : false;
      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this21.$notify.success('修改成功');

          _this21.getSystemInfo();
        } else {
          _this21.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this21.$notify.error('网络异常！修改失败');
      });
    },
    getBalances: function getBalances() {
      var _this22 = this;

      this.$zybhttp.get('Balance/GetBalance', {
        params: {
          balanceId: ''
        }
      }).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data.data.list;
          var tem_arr = [];

          for (var i = 0; i < d.length; i++) {
            if (d[i].balanceType == 1) {
              tem_arr[i] = d[i];
            }
          }

          _this22.balanceArr = tem_arr;
        } else {
          _this22.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this22.$notify.error('网络异常！获取列表失败！11');
      });
    },
    UpLog: function UpLog() {
      this.$router.push('CoalInforUploadRecord');
    },
    restoreDefaultColors: function restoreDefaultColors() {
      this.mineNumberArr.menuBarBackgroundColor = '#324157';
      this.mineNumberArr.homePageBackgroundColor = '#324157';
      this.mineNumberArr.titleColor = '#e8f4ff';
      this.mineNumberArr.textColor = '#ffffff';
      this.mineNumberArr.buttonColor = '#324157';
      this.mineNumberArr.buttonColor2 = '#576a86';
      this.mineNumberArr.connectionStatusColor = '#914';
    },
    saveColors: function saveColors() {
      var _this23 = this;

      this.$zybhttp.post('SystemInfo/SetSystemInfo', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this23.$notify.success('修改成功');

          _this23.getSystemInfo();
        } else {
          _this23.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this23.$notify.error('网络异常！修改失败');
      });
    }
  }
};